export enum F1TeamsEnum {
	RacingBulls = 'sr:competitor:5771',
	RedBull = 'sr:competitor:4978',
	AstonMartin = 'sr:competitor:496090',
	KickSauber = 'sr:competitor:4515',
	McLaren = 'sr:competitor:4514',
	Alpine = 'sr:competitor:4512',
	Williams = 'sr:competitor:4511',
	Ferrari = 'sr:competitor:4510',
	Mercedes = 'sr:competitor:41127',
	Haas = 'sr:competitor:242902',
}

export const F1TeamName: Record<F1TeamsEnum, string> = {
	[F1TeamsEnum.RacingBulls]: 'Racing Bulls',
	[F1TeamsEnum.RedBull]: 'Red Bull',
	[F1TeamsEnum.AstonMartin]: 'Aston Martin',
	[F1TeamsEnum.KickSauber]: 'Kick Sauber',
	[F1TeamsEnum.McLaren]: 'McLaren',
	[F1TeamsEnum.Alpine]: 'Alpine',
	[F1TeamsEnum.Williams]: 'Williams',
	[F1TeamsEnum.Ferrari]: 'Ferrari',
	[F1TeamsEnum.Mercedes]: 'Mercedes',
	[F1TeamsEnum.Haas]: 'Haas',
};

export const f1Teams: F1TeamsEnum[] = Object.values(F1TeamsEnum) as F1TeamsEnum[];
